import React, { useState } from "react";

export const TIME_PRESETS = [
    { label: "Morgens", from: "08:00", to: "12:00" },
    { label: "Mittags", from: "12:00", to: "15:00" },
    { label: "Nachmittag", from: "15:00", to: "19:00" },
    { label: "Abends", from: "19:00", to: "22:00" },
];

const BockModal = ({ onConfirm, onClose }) => {
    const [timeFrom, setTimeFrom] = useState("15:00");
    const [timeTo, setTimeTo] = useState("19:00");

    const applyPreset = (preset) => {
        setTimeFrom(preset.from);
        setTimeTo(preset.to);
    };

    const valid = timeFrom && timeTo && timeTo > timeFrom;

    return (
        <div
            style={{
                position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
                display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000,
            }}
            onClick={onClose}
        >
            <div
                style={{
                    background: "#fff", borderRadius: 8, padding: 24,
                    width: "90%", maxWidth: 360, boxShadow: "0 4px 24px rgba(0,0,0,0.2)",
                }}
                onClick={e => e.stopPropagation()}
            >
                <h3 style={{ marginTop: 0, marginBottom: 16 }}>Wann hast du Zeit?</h3>

                <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 }}>
                    {TIME_PRESETS.map(p => (
                        <button
                            key={p.label}
                            onClick={() => applyPreset(p)}
                            style={{
                                padding: "6px 12px",
                                border: "1px solid #4CAF50",
                                borderRadius: 4,
                                background: timeFrom === p.from && timeTo === p.to ? "#4CAF50" : "#fff",
                                color: timeFrom === p.from && timeTo === p.to ? "#fff" : "#4CAF50",
                                cursor: "pointer",
                                fontSize: 13,
                            }}
                        >
                            {p.label}
                        </button>
                    ))}
                </div>

                <div style={{ display: "flex", gap: 12, marginBottom: 20, alignItems: "center" }}>
                    <div style={{ flex: 1 }}>
                        <label style={{ fontSize: 12, color: "#666", display: "block", marginBottom: 4 }}>Von</label>
                        <input
                            type="time"
                            value={timeFrom}
                            onChange={e => setTimeFrom(e.target.value)}
                            style={{ width: "100%", padding: "6px 8px", border: "1px solid #ddd", borderRadius: 4 }}
                        />
                    </div>
                    <div style={{ flex: 1 }}>
                        <label style={{ fontSize: 12, color: "#666", display: "block", marginBottom: 4 }}>Bis</label>
                        <input
                            type="time"
                            value={timeTo}
                            onChange={e => setTimeTo(e.target.value)}
                            style={{ width: "100%", padding: "6px 8px", border: "1px solid #ddd", borderRadius: 4 }}
                        />
                    </div>
                </div>

                {!valid && timeFrom && timeTo && (
                    <p style={{ color: "#e65100", fontSize: 12, marginBottom: 12 }}>
                        Endzeit muss nach Startzeit liegen.
                    </p>
                )}

                <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                    <button
                        onClick={onClose}
                        style={{
                            padding: "8px 16px", border: "1px solid #ddd",
                            background: "#fff", borderRadius: 4, cursor: "pointer",
                        }}
                    >
                        Abbrechen
                    </button>
                    <button
                        onClick={() => valid && onConfirm(timeFrom, timeTo)}
                        disabled={!valid}
                        style={{
                            padding: "8px 16px", border: "none",
                            background: valid ? "#4CAF50" : "#ccc",
                            color: "#fff", borderRadius: 4,
                            cursor: valid ? "pointer" : "not-allowed",
                            fontWeight: "bold",
                        }}
                    >
                        Bock bestätigen
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BockModal;
